import { render, staticRenderFns } from "./DialogCreateDepartment.vue?vue&type=template&id=4c51daca&scoped=true&"
import script from "./DialogCreateDepartment.vue?vue&type=script&lang=js&"
export * from "./DialogCreateDepartment.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreateDepartment.vue?vue&type=style&index=0&id=4c51daca&lang=scss&scoped=true&"
import style1 from "./DialogCreateDepartment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51daca",
  null
  
)

export default component.exports